import { GridColDef } from "@mui/x-data-grid";
import { renderActive } from "../../../../component/list/table-column-renders";
import { StudentGroup } from "../../model/stream";
import { Button } from "@mui/material";
import PeopleIcon from '@mui/icons-material/People';

export const columns = (openMembers: (group: StudentGroup) => void): GridColDef[] => [
    { field: 'name', headerName: 'Name', flex: 1.5 },
    { field: 'groupEmail', headerName: 'Group email', flex: 1.5 },
    { field: 'active', headerName: 'Active', flex: 0.5, renderCell: (params) => { return renderActive(params.row.active) } },
    {
        field: 'actions',
        headerName: 'Members',
        flex: 0.5,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
            return (
                <Button
                    size="small"
                    startIcon={<PeopleIcon />}
                    onClick={(e) => {
                        e.stopPropagation();
                        openMembers(params.row as StudentGroup);
                    }}
                >
                    Members
                </Button>
            );
        }
    }
];
